import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function TestimonyCard({ name, major, detail, image, containerRef }) {
  const [expanded, setExpanded] = useState(false);
  const cardRef = useRef(null);

  // ✅ Automatically scroll card into view when expanded
  useEffect(() => {
    if (expanded && cardRef.current && containerRef?.current) {
      const container = containerRef.current;
      const card = cardRef.current;
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const containerWidth = container.offsetWidth;
      const scrollTo = cardLeft - containerWidth / 2 + cardWidth / 2;

      container.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });
    }
  }, [expanded, containerRef]);

  return (
    <motion.div
      ref={cardRef}
      className="testimony-card"
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      layout  // ✅ smooth height transition
      transition={{ layout: { duration: 0.4, type: "spring" } }}
    >
      {/* Profile image circle - only show when image is provided */}
      {image && (
        <div className="testimony-avatar">
          <img src={image} alt={name} className="testimony-avatar-img" />
        </div>
      )}
      <h3 className="testimony-name">{name}</h3>
      <p className="testimony-major">{major}</p>

      <AnimatePresence initial={false}>
        {expanded ? (
          <motion.p
            key="expanded"
            className="testimony-detail"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {detail}
          </motion.p>
        ) : (
          <motion.p
            key="collapsed"
            className="testimony-detail collapsed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {detail.length > 200 ? detail.substring(0, 200) + "..." : detail}
          </motion.p>
        )}
      </AnimatePresence>

      {detail.length > 200 && (
        <button
          className="testimony-toggle"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Read more"}
        </button>
      )}
    </motion.div>
  );
}
